import { render } from "./roles-permissions.vue?vue&type=template&id=0ccff578"
import script from "./roles-permissions.vue?vue&type=script&lang=js"
export * from "./roles-permissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__